var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full relative"},[(_vm.renderer && _vm.camera && _vm.rayplay && _vm.controls && _vm.ready)?_c('CityLayout'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }